export const strings = {
  en: {
    descriptionTitle: ({ nonprofitName = "a nonprofit" }) => `You just made an impact for ${nonprofitName}`,
    descriptionSubtitle: ({ brandName = "" }) => `Check out the impact your ${brandName} purchase made below.`,
    yourImpactTitle: () => `You’re funding`,
    communityImpactTitle: () => `Together we’re funding`,
    personalImpactLinkCopy: ({ nonprofitName = "" }) => `Learn about ${nonprofitName}`,
    communityImpactLinkCopy: ({ brandName = "" }) => `See all of the ${brandName} community's impact`,
    // share modal
    impactShareButton: () => `Share to Grow Your Impact`,
  },
  fr: {
    descriptionTitle: ({ nonprofitName = "une organisation" }) => `Vous avez créé un impact pour ${nonprofitName}`,
    descriptionSubtitle: ({ brandName = "" }) => `Découvrez ci-dessous l'impact de votre achat ${brandName}.`,
    yourImpactTitle: () => `Vous financez`,
    communityImpactTitle: () => `Ensemble, nous finançons`,
    personalImpactLinkCopy: ({ nonprofitName = "" }) => `En savoir plus sur ${nonprofitName}`,
    communityImpactLinkCopy: ({ brandName = "" }) => `Voir tout l'impact de la communauté ${brandName}`,
    // share modal
    impactShareButton: () => `Partagez pour développer votre impact`,
  },
  de: {
    descriptionTitle: ({ nonprofitName = "eine Organisation" }) =>
      `Du hast einen Beitrag für ${nonprofitName} geleistet`,
    descriptionSubtitle: ({ brandName = "" }) =>
      `Sieh dir unten den Beitrag an, den dein ${brandName} Einkauf gemacht hat.`,
    yourImpactTitle: () => `Du finanzierst`,
    communityImpactTitle: () => `Gemeinsam finanzieren wir`,
    personalImpactLinkCopy: ({ nonprofitName = "" }) => `Mehr über ${nonprofitName} erfahren`,
    communityImpactLinkCopy: ({ brandName = "" }) => `Sieh dir den gesamten Beitrag der ${brandName}-Community an`,
    // share modal
    impactShareButton: () => `Teile, um deinen Beitrag zu vergrößern`,
  },
  es: {
    descriptionTitle: ({ nonprofitName = "una organización" }) => `Generaste un impacto para ${nonprofitName}`,
    descriptionSubtitle: ({ brandName = "" }) =>
      `Mira a continuación el impacto que tu compra de ${brandName} ha generado.`,
    yourImpactTitle: () => `Estás financiando`,
    communityImpactTitle: () => `Juntos estamos financiando`,
    personalImpactLinkCopy: ({ nonprofitName = "" }) => `Conoce más sobre ${nonprofitName}`,
    communityImpactLinkCopy: ({ brandName = "" }) => `Mira todo el impacto de la comunidad ${brandName}`,
    // share modal
    impactShareButton: () => "Comparte para hacer crecer tu impacto",
  },
  it: {
    descriptionTitle: ({ nonprofitName = "un'organizzazione" }) => `Hai creato un impatto per ${nonprofitName}`,
    descriptionSubtitle: ({ brandName = "" }) => `Scopri qui sotto l'impatto del tuo acquisto ${brandName}.`,
    yourImpactTitle: () => `Stai finanziando`,
    communityImpactTitle: () => `Insieme stiamo finanziando`,
    personalImpactLinkCopy: ({ nonprofitName = "" }) => `Scopri di più su ${nonprofitName}`,
    communityImpactLinkCopy: ({ brandName = "" }) => `Guarda tutto l'impatto della comunità ${brandName}`,
    // share modal
    impactShareButton: () => "Condividi per far crescere il tuo impatto",
  },
  pl: {
    descriptionTitle: ({ nonprofitName = "organizację" }) => `Wywarłaś_eś wpływ na ${nonprofitName}`,
    descriptionSubtitle: ({ brandName = "" }) => `Sprawdź poniżej, jaki wpływ miał Twój zakup ${brandName}.`,
    yourImpactTitle: () => `Finansujesz`,
    communityImpactTitle: () => `Razem finansujemy`,
    personalImpactLinkCopy: ({ nonprofitName = "" }) => `Dowiedz się więcej o ${nonprofitName}`,
    communityImpactLinkCopy: ({ brandName = "" }) => `Zobacz cały wpływ społeczności ${brandName}`,
    // share modal
    impactShareButton: () => `Udostępnij, aby powiększyć swój wpływ`,
  },
};
